
import { computed, defineComponent, onMounted, reactive, ref, watch } from 'vue';
import { CustomerRaffle, useRaffle } from '@/compositions/useRaffle';
import { datetimeFormat } from '@/utils';
import { StateChanger } from 'vue-infinite-loading';
import { useRoute, useRouter } from 'vue-router/composables';
import { RaffleParsed } from '@comsbi/common/src/types/models';

export default defineComponent<{ raffle: RaffleParsed }>({
  name: 'RaffleHistory',

  props: {},

  components: {},

  setup() {
    const { resolve, loadHistory } = useRaffle();
    const route = useRoute();
    const router = useRouter();

    const state = reactive<{ id: string; data: CustomerRaffle | null; from: number; limit: number }>({
      id: route.params.id,
      data: null,
      from: 0,
      limit: 50, // パフォーマンス次第で調整
    });

    const _loadContents = async () => {
      state.data = (await resolve(state.id)).result || null;
    };

    const settings = computed(() => {
      return state.data?.raffle.settings;
    });

    const type = computed(() => {
      return settings.value?.type;
    });

    onMounted(async () => {
      // Set title

      await _loadContents();
    });

    watch(
      () => route,
      async (to, from) => {
        // パス更新
        state.id = to.params.id;
        await _loadContents();
      }
    );

    const draws = ref<any[]>([]);

    const infiniteHandler = async ($state: StateChanger) => {
      try {
        // RaffleTransfer取得
        const {
          result: { history: _draws },
        } = await loadHistory(state.data!.raffleId, state.from, state.limit);
        if (_draws.length) {
          draws.value.push(..._draws);
          state.from += _draws.length;
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (e) {
        $state.error();
        throw e;
      }
    };

    onMounted(async () => {
      // Raffle取得
    });

    return {
      state,
      draws,
      infiniteHandler,
      getDrawLabel(draw: any) {
        //
        if (type.value === 'OFFLINE') {
          return `${draw.value.N}回`;
        }
        // ONLINE
        if (draw.action === 'lose') return 'はずれ';

        // あたり
        const prizeId = draw.value.K;
        const prize = settings.value?.prizes.find(prize => prize.id === prizeId);

        return prize?.name;
      },

      datetimeFormat,
    };
  },
});
